import createBasicPromise from "./createBasicPromise";
var promiseToLoadScript = function (url) {
    return "(" + createBasicPromise + "(\n    function loadScript(resolve) {\n      var s = document.createElement(\"script\");\n      s.async = true;\n      s.setAttribute(\"src\", \"" + url + "\");\n      s.addEventListener(\"load\", resolve);\n      document.head.appendChild(s);\n    }\n  ))";
};
export default promiseToLoadScript;
//# sourceMappingURL=promiseToLoadScript.js.map